import KeenSlider from 'keen-slider'
import { keyboard, dots, arrows, autoPlay } from './slider-plugins'

const initSlider = () => {
  const sliders = document.querySelectorAll('.keen-slider')

  if (!sliders?.length) return

  const animation = { duration: 10000, easing: (t) => t }

  sliders.forEach((slider) => {
    const config = {
      drag: slider.classList.contains('slider--grab'),
      loop: slider.classList.contains('slider--loop'),
      mode: slider.classList.contains('slider--snap') ? 'snap' : 'free',
      renderMode: 'performance',

      slides: {
        perView: slider.dataset.cols,
        spacing: 80,
      },
    }

    if (slider.classList.contains('slider--auto')) {
      config.created = (s) => s.moveToIdx(5, true, animation)
      config.updated = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
      config.animationEnded = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
    }

    new KeenSlider(slider, config, [keyboard, dots])
  })
}

initSlider()
